<template>
    <div class="example-simple">
        <div class="form-group">
            <label for="typeFile">Nom du fichier (obligatoire)</label>
            <input type="text" class="form-control" id="typeFile" name="fileName"
                   placeholder="Ex: Photo, Déclaration d'accident, Poolist, ..."
                   v-model="fileName"
            >
            <small>Veuillez entrer un nom de fichier avant de sélectionner le fichier</small>

        </div>
        <div id="example-title" class="example-title">Fichier à envoyer:</div>
        <div class="fileUploadComponent">

            <ul>
                <li v-for="(file, index) in files" :key="file.id">
                    <span>{{file.name}}</span>
                    <span class="text-red" v-if="file.error">ERREUR - {{file.error}}</span>
                    <span class="text-green" v-else-if="file.success"> - Envoyé</span>
                    <span class="text-blue" v-else-if="file.active"> - En cours... </span>
                    <span class="text-blue" v-else-if="file.active"> - En cours... </span>
                    <span v-else></span>
                </li>
            </ul>
            <div class="example-btn">
                <file-upload
                        class="btn btn-primary"
                        :input-id="morph+id_morph"
                        :headers="{'Authorization': 'Bearer '+getAuth.accessToken}"
                        :data="dataToSend"
                        :post-action="urlPost"
                        :disabled="fileName==''"
                        extensions="zip,pdf,gif,jpg,jpeg,png,webp"
                        accept="application/pdf,application/zip,image/png,image/gif,image/jpeg,image/webp"
                        :multiple="false"
                        :size="0"
                        v-model="files"
                        :xhr="true"
                        @input-file="inputFile"
                        @input-filter="inputFilter"
                        ref="fileUploadComponent">
                    <i class="fa fa-plus"></i>
                    Selectionner le fichier
                </file-upload>

                <button
                        :disabled="fileName=='' || files.length==0"
                        type="button" class="btn btn-success" v-if="!uploadComponent || !uploadComponent.active"
                        @click.prevent="uploadFiles">
                    <i class="fa fa-arrow-up" aria-hidden="true"></i>
                    Envoyer
                </button>

                <button type="button" class="btn btn-danger" v-else @click.prevent="uploadComponent.active = false">
                    <i class="fa fa-stop" aria-hidden="true"></i>
                    Annuler
                </button>
            </div>
        </div>
    </div>
</template>
<style>
    .example-simple label.btn {
        margin-bottom: 0;
        margin-right: 1rem;
    }
</style>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import FileUpload from 'vue-upload-component'

    export default {
        props: {
            urlPost: {
                type: String,
                default: function () {
                    return ""
                }
            },
            morph: null,
            id_morph: null,

        },
        components: {
            FileUpload,
        },
        computed: {
            ...mapGetters({
                getAuth: 'getAuth',
            }),
            // dataToSend: function () {
            //     if (this.morph != null && this.id_morph != null)
            //         return {
            //             type: this.morph,
            //             id_type: this.id_morph,
            //             fileName: this.fileName
            //         }
            // }
        },
        watch: {
            'fileName': function () {
                this.constructDataToSend()
            },
            'morph': function () {
                this.constructDataToSend()
            },
            'id_morph': function () {
                this.constructDataToSend()
            },
            'files': function () {
                this.constructDataToSend()
                this.$emit('filesUpdated', this.files)
            },
            'uploaded': function (value) {
                if (value) {
                    this.uploadComponent.clear();
                    this.$emit('filesUploaded', true)
                    this.files = []
                    this.fileName = ""
                    this.uploaded = false
                }
            }
        },
        data() {
            return {
                dataToSend: {
                    type: null,
                    id_type: null,
                    fileName: null,
                },
                files: [],
                uploadComponent: null,
                fileName: "",
                uploaded: false
            }
        },

        methods: {
            uploadFiles: function () {
                this.constructDataToSend()
                this.uploadComponent.active = true
            },
            constructDataToSend: function () {
                if (this.morph != null && this.id_morph != null) {
                    this.dataToSend = {
                        type: this.morph,
                        id_type: this.id_morph,
                        fileName: this.fileName
                    }
                    // this.uploadComponent.data = this.dataToSend
                }
                else
                    this.dataToSend = null
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                    if (newFile.file && newFile.type.substr(0, 6) === 'image/' && this.autoCompress > 0 && this.autoCompress < newFile.size) {
                        newFile.error = 'compressing'
                        const imageCompressor = new ImageCompressor(null, {
                            convertSize: Infinity,
                            maxWidth: 512,
                            maxHeight: 512,
                        })
                        imageCompressor.compress(newFile.file)
                            .then((file) => {
                                this.$refs.upload.update(newFile, {error: '', file, size: file.size, type: file.type})
                            })
                            .catch((err) => {
                                this.$refs.upload.update(newFile, {error: err.message || 'compress'})
                            })
                    }
                }
                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                    newFile.blob = ''
                    let URL = window.URL || window.webkitURL
                    if (URL && URL.createObjectURL) {
                        newFile.blob = URL.createObjectURL(newFile.file)
                    }
                    newFile.thumb = ''
                    if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                        newFile.thumb = newFile.blob
                    }
                }
            },
            inputFile: function (newFile, oldFile) {
                this.constructDataToSend()
                // console.log(this.uploadComponent)
                // console.log(this.uploadComponent)
                if (newFile && oldFile) {
                    if (newFile.success !== oldFile.success)
                        this.uploaded = true
                    else
                        this.uploaded = false
                }
            }
        },
        mounted() {
            this.$nextTick(function () {
                // debugger
                this.uploadComponent = this.$refs.fileUploadComponent;
            })
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Communs/UploadFiles.vue